// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flex-60[data-v-bb2e42dc]{flex:0 0 15rem}", "",{"version":3,"sources":["webpack://./resources/js/Vue/Components/Frontend/Includes/menu/MainSiteLogo.vue"],"names":[],"mappings":"AACA,0BACI,cAAA","sourcesContent":["\n.flex-60 {\n    flex: 0 0 15rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
